module.exports = __webpack_public_path__ + "static/contet-blocks-tracking-calm-4b171f51e535dce9895b43ba965cc298.jpg";